import styled from '@emotion/styled';
import {EventContentArg} from '@fullcalendar/core';
import React from 'react';
import {mixinFlexboxRow} from 'webapp-lib/styling';

import {
  TimeEntryCalendarEventExtendedProps,
  TimerFacade,
  TimerStartData,
} from '../timetracker.types';

import {PlayButton} from './PlayButton';

export function TimeEntryCalendarEvent({
  eventContent,
  timer,
}: {
  eventContent: EventContentArg;
  timer: TimerFacade;
}): React.ReactElement {
  const extendedProps = eventContent.event
    .extendedProps as TimeEntryCalendarEventExtendedProps;

  const casusDisplayName = extendedProps?.casus?.displayName;

  const timerData: TimerStartData = {
    title: eventContent.event.title,
    description: extendedProps?.description,
    casus: extendedProps.casus,
  };

  return (
    // default renderInnerContent taken from https://github.com/fullcalendar/fullcalendar/blob/3b56ca2d741a449b32f02548b0cec0bf06d3d368/packages/core/src/common/StandardEvent.tsx#L75-L88
    <div className='fc-event-main-frame'>
      <Header>
        {eventContent.timeText && (
          <div className='fc-event-time'>{eventContent.timeText}</div>
        )}
        <PlayButton
          isOngoing={extendedProps.ongoing || false}
          startTimer={() => timer.start(timerData)}
          stopTimer={timer.stop}
        />
      </Header>
      <div className='fc-event-title-container'>
        <div className='fc-event-title fc-sticky'>
          {casusDisplayName && (
            <AdditionalInfo>{casusDisplayName}</AdditionalInfo>
          )}
          <Title>{eventContent.event.title}</Title>
        </div>
      </div>
    </div>
  );
}

const Header = styled.div`
  ${mixinFlexboxRow};
  align-items: center;

  /* in the single-line short-event layout, dissolve the header so time, title
     and play button share one row, and push the play button (the header's
     last child) to the far right like in the two-line layout */
  .fc-timegrid-event-short & {
    display: contents;

    > :last-child {
      order: 1;
      margin-left: auto;
    }
  }
`;

export const AdditionalInfo = styled.div`
  display: inline-block;
`;

const Title = styled.div`
  font-weight: bold;
`;
